import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moreTealArrow from '../../../content/media-library/icons/more-teal-arrow.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const TextWithBackground = (props) => {
  const {
    colourScheme,
    textAlignment,
    title,
    imageAlignment,
    src,
    backgroundImage,
    backgroundImageAlt,
    mask,
    titleColour,
    noMobileBackground,
    mobileBackgroundToImage,
    textContain,
    readMoreLink,
    linkDescription,
    hideSection,
    customClass
  } = props;
  const componentClasses = classNames('text-wbg', {
    [`text-wbg--${colourScheme}-scheme${mobileBackgroundToImage ? '-on-desktop' : ''}`]: colourScheme,
    [textAlignment]: textAlignment,
    [imageAlignment]: imageAlignment,
    [`titles--${titleColour}`]: titleColour,
    'text-wbg--hide-bg-on-mobile': noMobileBackground || mobileBackgroundToImage,
    'text-wbg--featured-padding': mobileBackgroundToImage,
    [`text-contain-${textContain}`]: textContain,
    [`text-wbg--hide-section-on-${hideSection}`]: hideSection,
    [`text-wbg--${customClass}`]: customClass
  });
  return (
    <section
      className={componentClasses}
      style={{
        backgroundImage: `${
          mask ? 'linear-gradient(rgba(26,35,67,0.65), rgba(26,35,67,0.65)), ' : ''
        } url(${backgroundImage})`
      }}
    >
      {title ? <h2>{title}</h2> : null}
      {mobileBackgroundToImage ? (
        readMoreLink ? (
          <a href={readMoreLink}>
            {linkDescription ? <span className="screen-reader-text">{linkDescription}</span> : ''}
            <LazyLoadImage className="small-only" src={backgroundImage} alt={backgroundImageAlt} />
          </a>
        ) : (
          <LazyLoadImage className="small-only" src={backgroundImage} alt={backgroundImageAlt} />
        )
      ) : (
        ''
      )}
      <div className="text-wbg__text" dangerouslySetInnerHTML={{ __html: props[src] }} />
      {readMoreLink && (
        <a className="find-more-link" href={readMoreLink}>
          <strong>Read more </strong>
          <img alt="arrow-right" src={moreTealArrow} />
        </a>
      )}
    </section>
  );
};
TextWithBackground.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  backgroundImage: PropTypes.string,
  mask: PropTypes.string,
  colourScheme: PropTypes.oneOf(['dark-navy']),
  textAlignment: PropTypes.oneOf(['text-align-left', 'text-align-right']),
  imageAlignment: PropTypes.oneOf(['image-align-left', 'image-align-right']),
  titleColour: PropTypes.oneOf(['purple', 'dark-navy', 'teal']),
  hideSection: PropTypes.oneOf(['mobile']),
  noMobileBackground: PropTypes.bool,
  mobileBackgroundToImage: PropTypes.string,
  textContain: PropTypes.oneOf(['left', 'center']),
  readMoreLink: PropTypes.string,
  linkDescription: PropTypes.string
};
export default TextWithBackground;
